import { API_URL } from "../constants/api";
import { getAxios, postAxios } from "../helpers";

class ItemService {

  getAll(params = null) {
    let url = API_URL.ITEM.GET_ALL;
    return getAxios(url, params);
  }

  getById(id) {
    const url = API_URL.ITEM.GET_BY_ID.replace(":id", id);
    return getAxios(url);
  }

  create(params) {
    const url = API_URL.ITEM.CREATE;
    return postAxios(url, params);
  }

  updateById(id, params) {
    const url = API_URL.ITEM.UPDATE_BY_ID.replace(":id", id);
    return postAxios(url, params, "put");
  }

  deleteById(id) {
    const url = API_URL.ITEM.DELETE_BY_ID.replace(":id", id);
    return postAxios(url, {}, "delete");
  }

}

export default new ItemService();
